<template>
  <IconWrapper v-if="filled" name="group" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.949 14.5396C15.3802 14.5396 18.31 15.0836 18.31 17.2604C18.31 19.4362 15.399 20 11.949 20C8.51785 20 5.58809 19.456 5.58809 17.2802C5.58809 15.1034 8.49904 14.5396 11.949 14.5396ZM17.4351 13.2289C18.7468 13.2046 20.1571 13.3847 20.6782 13.5126C21.7823 13.7296 22.5084 14.1727 22.8093 14.8166C23.0636 15.3453 23.0636 15.9586 22.8093 16.4864C22.349 17.4851 20.8654 17.8058 20.2887 17.8886C20.1696 17.9066 20.0738 17.8031 20.0864 17.6833C20.3809 14.9157 18.0377 13.6035 17.4315 13.3018C17.4055 13.2883 17.4002 13.2676 17.4028 13.255C17.4046 13.246 17.4154 13.2316 17.4351 13.2289ZM6.5656 13.2292C6.5853 13.2319 6.59515 13.2464 6.59694 13.2545C6.59962 13.268 6.59425 13.2878 6.56918 13.3022C5.9621 13.6039 3.61883 14.9161 3.91342 17.6827C3.92595 17.8034 3.83104 17.9061 3.71195 17.889C3.13531 17.8061 1.65163 17.4855 1.19139 16.4867C0.936203 15.9581 0.936203 15.3457 1.19139 14.817C1.49225 14.1731 2.21752 13.73 3.32156 13.512C3.84358 13.385 5.25294 13.2049 6.5656 13.2292ZM11.949 4C14.2851 4 16.1583 5.88227 16.1583 8.23285C16.1583 10.5825 14.2851 12.4666 11.949 12.4666C9.61292 12.4666 7.73974 10.5825 7.73974 8.23285C7.73974 5.88227 9.61292 4 11.949 4ZM17.6634 4.7059C19.9198 4.7059 21.6918 6.84123 21.0883 9.21974C20.6809 10.821 19.2062 11.8846 17.5631 11.8414C17.3984 11.8369 17.2363 11.8216 17.0796 11.7946C16.9659 11.7748 16.9086 11.646 16.973 11.5505C17.5998 10.6229 17.9571 9.50703 17.9571 8.30922C17.9571 7.05918 17.5667 5.8938 16.8889 4.93825C16.8674 4.90853 16.8513 4.8626 16.8728 4.82838C16.8907 4.80046 16.9238 4.78605 16.9551 4.77884C17.1835 4.73201 17.4181 4.7059 17.6634 4.7059ZM6.33593 4.70581C6.58127 4.70581 6.81586 4.73192 7.04509 4.77875C7.07553 4.78596 7.10956 4.80127 7.12746 4.82829C7.14806 4.86251 7.13284 4.90844 7.11135 4.93816C6.43353 5.89371 6.04313 7.05909 6.04313 8.30913C6.04313 9.50694 6.4004 10.6228 7.02718 11.5504C7.09165 11.6459 7.03434 11.7747 6.92063 11.7945C6.76304 11.8224 6.60186 11.8368 6.43711 11.8413C4.79404 11.8845 3.31932 10.8209 2.91191 9.21965C2.30751 6.84114 4.07951 4.70581 6.33593 4.70581Z"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
  <IconWrapper v-else name="group" :color="color" fillMode="stroke">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.8877 10.8977C19.2827 10.7017 20.3567 9.5057 20.3597 8.0567C20.3597 6.6287 19.3187 5.4447 17.9537 5.2207"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.7285 14.25C21.0795 14.452 22.0225 14.925 22.0225 15.9C22.0225 16.571 21.5785 17.007 20.8605 17.281"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.8867 14.6641C8.67273 14.6641 5.92773 15.1511 5.92773 17.0961C5.92773 19.0401 8.65573 19.5411 11.8867 19.5411C15.1007 19.5411 17.8447 19.0591 17.8447 17.1131C17.8447 15.1671 15.1177 14.6641 11.8867 14.6641Z"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.8864 11.888C13.9954 11.888 15.7054 10.179 15.7054 8.069C15.7054 5.96 13.9954 4.25 11.8864 4.25C9.77744 4.25 8.06741 5.96 8.06741 8.069C8.05944 10.171 9.75644 11.881 11.8584 11.888H11.8864Z"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.88509 10.8977C4.48909 10.7017 3.41609 9.5057 3.41309 8.0567C3.41309 6.6287 4.45409 5.4447 5.81909 5.2207"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.044 14.25C2.693 14.452 1.75 14.925 1.75 15.9C1.75 16.571 2.194 17.007 2.912 17.281"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
  filled?: boolean
}>()
</script>
